import feShellNavigate from 'od-modules/frontend-shell/navigate';
import navigationEventController from './navigationEventController';

/**
 * Tool for create route handler
 * @example
 *    routes: {
 *      'test/:testParam/': 'test',
 *    },
 *    handlers: {
 *      ...routeHandler('test', () => ([{viewEvents: {}, eventHandlers: {}}]))
 *    },
 * @param {object} frontendShell The frontendShell module
 * @param {string} page The page name
 * @param {function(): *[]} extendEventController callback that returns a list of custom view or global events
 * @return {function} Function handler
 */
export default (frontendShell, page, extendEventController = () => []) => {
    return {
        [page]: (...args) => {
            $('body').off(Odigeo.Events.tap, '[data-href]');
            $('#page')
                .removeClass()
                .addClass(page);
            $.extend(true, Odigeo.Router.eventController, navigationEventController, ...extendEventController());
            Odigeo.Router.eventController.execute();
            feShellNavigate(frontendShell, page, args);
        },
    };
};
